module.exports = __webpack_public_path__ + "img/pic_3.9816e5df.png";